// external
import React from 'react';

// interstate
import { Box } from '@interstate/components/Box';
import { Button } from '@interstate/components/Button';

interface ClearTaxesButtonProps {
    onClick: () => void;
}

const ClearTaxesButton: React.FC<ClearTaxesButtonProps> = React.memo(({ onClick }) => (
    <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button data-testid="clear-amounts-button" type="button" size="default" buttonStyle="tertiary" onClick={onClick}>
            Clear Taxes
        </Button>
    </Box>
));

ClearTaxesButton.displayName = 'ClearTaxesButton';

export default ClearTaxesButton;
